module.exports = __webpack_public_path__ + "img/work_in_mask.bf642a50.svg";